import { Component } from "react";
import TextFilter from "./TextFilter";
import CategoryFilters from "./CategoryFilters";
import BlockTypeFilters from "./BlockTypeFilters";
import ElementSpacer from "../../utilities/ElementSpacer";
import { observer } from "mobx-react";
import { StoreContext } from "../../../stores/StoreContext";
import styles from "./styles/Filters.module.scss";
import withTranslateClassName from "./withTranslateClassName";

interface IFiltersProps {
  textFilter?: boolean;
  categoryFilters?: boolean;
  tagFilters?: boolean;
  blockTypes?: boolean;
  blockTypeFilters?: boolean;
  isSearchingGoogleDrive?: boolean;
  isSearchingOffice365Drive?: boolean;
  textCategorySearch?: boolean;
  textFilterPlaceholder?: string;
  translateClassName?: string;
  toggleMap?: () => void;
}

@observer
class Filters extends Component<IFiltersProps> {
  static contextType = StoreContext;
  declare context: React.ContextType<typeof StoreContext>;

  static defaultProps = {
    textFilter: false,
    categoryFilters: false,
    tagFilters: false,
    blockTypeFilters: false,
    isSearchingGoogleDrive: false,
    isSearchingOffice365Drive: false,
  };

  render() {
    const { textFilter, categoryFilters, tagFilters, blockTypeFilters } =
      this.props;

    let filterBarHtml: React.ReactNode = null,
      textFilterHtml: React.ReactNode = null,
      blockTypeFilterHtml: React.ReactNode = null,
      categoryFiltersHtml: React.ReactNode = null;

    if (textFilter || tagFilters) {
      if (textFilter) {
        textFilterHtml = (
          <TextFilter
            toggleMap={this.props.toggleMap}
            textCategorySearch={this.props.textCategorySearch}
            withCategoryFilter={!!categoryFilters}
            textFilterPlaceholder={this.props.textFilterPlaceholder}
          />
        );
      }

      filterBarHtml = textFilterHtml;
    }

    if (categoryFilters) {
      categoryFiltersHtml = <CategoryFilters />;
    }

    if (blockTypeFilters) {
      blockTypeFilterHtml = (
        <BlockTypeFilters
          isSearchingGoogleDrive={this.props.isSearchingGoogleDrive}
          isSearchingOffice365Drive={this.props.isSearchingOffice365Drive}
        />
      );
    }

    return (
      <div
        className={`${styles.filterContainerWrapper} sb-content-width ${this.props.translateClassName}`}
      >
        <div className={styles.filterContainer}>
          {filterBarHtml}
          {categoryFiltersHtml}
          {this.context.interfaceStore.breakpoint !== "break-point-xs" &&
            blockTypeFilterHtml}
          <ElementSpacer />
        </div>
      </div>
    );
  }
}

export default withTranslateClassName(Filters);
